export class Configurations {
    // Declaro las variables de configuración que voy a recibir al cargar el módulo
    public app: any;
    public googleApiKey = '';
    public hereApiKey = '';
    public mapId? = '';

    constructor() { }
}